// @flow

import { type PendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { type Gateway } from './types';

function getGateway(incomingPayment: PendingIncomingPayment): ?Gateway {
  return incomingPayment['gateway'];
}

export function getSafeGateway(incomingPayment: PendingIncomingPayment): Gateway {
  const gateway = getGateway(incomingPayment);

  if (!gateway)
    throw new Error('GetGateway: gateway is not available in incoming payment');

  return gateway;
}
